# Короткий список коллекций (id+title) для CollectionsField и
# AddToCollectionButton (референс грузил rowsPerPage: 1000 без поиска)
query CollectionOptions(
  $page: Int
  $rowsPerPage: Int
  $filter: ContentsFilterInput
) {
  contents(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      title
    }
  }
}
